export function setColumnFilterValue(columnFilterVal, listaValores) {
  //console.log('setColumnFilterValue');
  //console.log(columnFilterVal);
  
    let filtros = Object.entries(columnFilterVal)
    // console.log(filtros);
    // console.log("filtros antes");

    // Eliminar columnas vacías de anteriores filtrados
    filtros = filtros.filter(filtro => filtro[1] !== undefined && filtro[1] !== "")
    // console.log(filtros);
    // console.log("filtros despues");


    listaValores = listaValores.filter(lote => {
        if (filtros.every(columna => {
              const valor = String(lote[columna[0]]).toLowerCase()
              const filtroColumna = String(columna[1]).toLowerCase()
              // console.log(`valor`, valor.search(columna[1]));
              /*if (/*columna[0] === "numeroExpedienteConcurso" || columna[0] === "numero" || columna[0] === "nombreConcurso"){
                return valor === filtroColumna
              }*/
              return valor.search(filtroColumna) > -1
          })){

            return lote
            
          }
    });
    // console.log("lotesOfertadosFiltrados", listaValores);
    return listaValores
}
export function setTableFilterValue(tableFilterVal, listaValores) {
  //console.log('setTableFilterValue');
    listaValores = listaValores.filter(lote => {
      if (Object.values(lote).some(valor => {
        valor = String(valor).toLowerCase()
        const filtroTabla = String(tableFilterVal).toLowerCase()
        
        return valor.search(filtroTabla) > -1
        } ) ){
          return lote
        }
    });
    // console.log("lotesOfertadosFiltrados", lotesOfertadosFiltrados);

    return listaValores
}